
import {FrontWebPodcastEpisodeModel} from "../../../generated";
import {useSelector} from "react-redux";
import { RootState} from "../../Store";
import { useProgress} from "../../Player/progress";
import {startTransition, useEffect, useState} from "react";
import RadioCss from "../Style.module.scss";
import { ProgressBar} from "../../ProgressBar";
import { ToTime } from "./utils";
import { useSlugifyPath } from "../../../contexts/useRadio";
import { slugifyPath} from "../../../utils/slugifyPath";
import {usePodcastTime} from "../../../contexts/usePodcastTimes";


import playedsvg from "../../../static/played.svg"
export const EpisodeSlider = (props: { episode: FrontWebPodcastEpisodeModel, asHref?: boolean, className?: string, withAddRemoveSeconds?: boolean }) => {

    const slugifyPathCtx = useSlugifyPath();
    const path = slugifyPathCtx(props.episode, true);

    const savedTime = usePodcastTime(props.episode.id)
    const storageSavedTime = useSelector((state: RootState) => state.positions.find(x => x.slug === path)?.time) ??  0;
    const played = savedTime ? savedTime : storageSavedTime;
    const inputPlayedItem = useSelector((state: RootState) => state.playedItem);
    const progress = useProgress();

    const [position,setPosition] = useState(0);


    useEffect(() => {
        startTransition(()=> {
            setPosition(played);
        });
        // eslint-disable-next-line
    }, [played]);

    useEffect(() => {
        if (!inputPlayedItem)
            return;

        if (slugifyPath(inputPlayedItem, true) === path )
        {
            return progress.addListener((c) => {
                if (props.episode.duration < c)
                    c = props.episode.duration;
                if (c < 0)
                    c = 0;
                setPosition(c);
            })
        }
    }, [inputPlayedItem, props.episode, played, progress, path]);

    const time = (() => {
        if (props.episode.duration < 60)
        {
            return "1 minuta";
        }
        else if (props.episode.duration < 4 * 60) {
            return `${Math.floor(props.episode.duration / 60)} minuty`;
        }
        else {
            return `${Math.floor(props.episode.duration / 60)} minut`;
        }
    })();

    const progressBar = <ProgressBar className={`${RadioCss.ProgressTime} ${props.className ?? ''} align-self-center flex-fill`}  value={position / props.episode.duration} onChange={(e, ev)=> {
        if (props.asHref)
            return;
        ev.preventDefault();
        progress.setPosition(e * props.episode.duration, props.episode);
    }} />;

    if (position < 5) {
        return <>
            <span className={`${RadioCss.minutes} align-self-center ${props.className ?? ''}`}>{time}</span>
            {props.withAddRemoveSeconds ? progressBar : null}
        </>;
    }



    const [zbyva, full] = (() => {
        if (position >= props.episode.duration-2  )
            return [<span key={"played"} className={RadioCss.playedGreen}><img width={17} height={12} alt="" src={playedsvg} />&nbsp;&nbsp;&nbsp;Přehráno</span>, true];
        else if (position === 0) {
            return ["", false];
        }
        else {
            return [ToTime(`${Math.floor((props.episode.duration - position) / 60)}`), false];
        }
    })();

    return <>
        {zbyva ? <span className={`${RadioCss.minutes} ${props.className ?? ''} align-self-center`}>{zbyva}</span> : false}
        {!full || props.withAddRemoveSeconds ? progressBar : null}
    </>
}